export const getCopyableInitialValues = (fields = [], values = {}) => {
  if (!values || typeof values !== "object" || Array.isArray(values)) {
    return {};
  }

  const copyableValues = {};

  fields.forEach((field) => {
    const fieldId = field?.id;
    if (fieldId === undefined || fieldId === null || fieldId === "") {
      return;
    }

    if (field.readOnly || field.lockedForStep || field.autoFillSource) {
      return;
    }

    if (Object.prototype.hasOwnProperty.call(values, fieldId)) {
      copyableValues[fieldId] = values[fieldId];
    }
  });

  return copyableValues;
};
